module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Apply Rouge Rewards',
        apply: 'Apply',
        applied: 'Applied',
        remove: 'Remove',
        bopisRougeMessage: 'Only eligible in your',
        bopisRougeMessageRedirect: 'Shipping and Delivery basket',
        rougeRewardsMessage: `<b>$${vars[0]} off</b> • ️Exp ${vars[1]}`,
        rougeRewardsAppliedMessage: `<b>$${vars[0]} off</b> applied`
    };

    return resources[label];
};
